module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2 pa-0",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', {
          ref: "sortableTbody"
        }, _vm._l((_vm.localItems), function(item, index) {
          return _c('tr', {
            key: item.key,
            staticStyle: {
              "border-bottom": "1px solid #ededed"
            },
            attrs: {
              "data-id": item.key
            }
          }, [(_vm.isSort) ? _c('td', {
            staticClass: "sort-handle",
            staticStyle: {
              "width": "20px",
              "cursor": "grab"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-arrow-all")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "50px",
              "text-align": "right"
            }
          }, [_c('v-checkbox', {
            staticClass: "mt-1 pb-2 d-inline-block",
            attrs: {
              "label": "",
              "true-value": true,
              "false-value": false,
              "color": "primary",
              "hide-details": ""
            },
            model: {
              value: (_vm.localItems[index].value),
              callback: function($$v) {
                _vm.$set(_vm.localItems[index], "value", $$v)
              },
              expression: "localItems[index].value"
            }
          })], 1)])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f9557e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/TableColsShowHideModal.vue
// module id = 2234
// module chunks = 0